"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.picker.search.mode': 'Tryb Wyszukiwania',
    'knowledge.picker.search.knowledge': 'Wpisy Wiedzy',
    'knowledge.picker.search.projects': 'Projekty',
    'knowledge.picker.search.knowledge.label': 'Szukaj Wpisów Wiedzy - przypisz wiedzę do awatara',
    'knowledge.picker.search.knowledge.placeholder': 'Szukaj wpisów wiedzy...',
    'knowledge.picker.search.projects.label': 'Szukaj Projektów - przypisz projekt do awatara',
    'knowledge.picker.search.projects.placeholder': 'Szukaj projektów...',
    'knowledge.picker.search.clear': 'Wyczyść wyszukiwanie',
    'knowledge.picker.selected.knowledge': 'Wybrane Wpisy Wiedzy',
    'knowledge.picker.selected.projects': 'Wybrane Projekty',
    'knowledge.picker.table.name': 'Nazwa',
    'knowledge.picker.table.project': 'Projekt',
    'knowledge.picker.table.format': 'Format',
    'knowledge.picker.table.size': 'Rozmiar',
    'knowledge.picker.table.description': 'Opis',
    'knowledge.picker.remove': 'Usuń',
    'knowledge.picker.confirmRemove': 'Czy na pewno chcesz usunąć ten wpis wiedzy?',
    'knowledge.picker.no.results': 'Nie znaleziono elementów',
    'knowledge.picker.1to1mode': 'Tryb 1:1 (Pełna zawartość)',
    'knowledge.picker.tooltip': 'Wybierz pliki dla asystenta AI lub dodaj własne',
};
